import React, { FunctionComponent } from 'react';

import { Notification, Title } from '@xsolla/ui-core';
import { AlertExclamation } from '@xsolla/ui-icons';

import { NotificationWrapper, SubtitleWrapper, Wrapper } from './styles';

type Props = {
  title: string;
  subtitle?: string | React.ReactNode;
  notification?: string | React.ReactNode;
  notificationLink?: string | React.ReactNode;
  notificationMargin?: number;
  notificationIcon?: FunctionComponent;
  dataTestIdPrefix?: string;
};

const HeaderTitle = ({
  title,
  subtitle,
  notification,
  notificationLink,
  notificationMargin = 32,
  notificationIcon,
  dataTestIdPrefix
}: Props): JSX.Element => (
  <Wrapper>
    <Title center indent="sm" data-test-id={`ht_${dataTestIdPrefix}_title`}>
      {title}
    </Title>
    {subtitle && (
      <SubtitleWrapper data-test-id={`ht_${dataTestIdPrefix}_subtitle`}>{subtitle}</SubtitleWrapper>
    )}
    {notification && (
      <NotificationWrapper
        marginTop={notificationMargin}
        data-test-id={`ht_${dataTestIdPrefix}_notification`}>
        <Notification palette="brand" icon={notificationIcon || AlertExclamation}>
          {notification}
        </Notification>
        <div>{notificationLink}</div>
      </NotificationWrapper>
    )}
  </Wrapper>
);

export default HeaderTitle;
